import React from 'react';
import { Box, MenuItem, TextField } from '@mui/material';
import { COLORWAYS, ColorwayId } from '../../theme/createDealSkoutTheme';
import { useThemeMode } from '../../theme/ThemeModeProvider';

const ColorwayPicker: React.FC = () => {
  const { colorway, setColorway } = useThemeMode();
  return (
    <TextField
      select
      size="small"
      label="Colorway"
      value={colorway}
      onChange={(event) => setColorway(event.target.value as ColorwayId)}
      inputProps={{ 'aria-label': 'Colorway' }}
      sx={{ minWidth: 168, '& .MuiInputBase-root': { minHeight: 44 } }}
    >
      {COLORWAYS.map((item) => (
        <MenuItem key={item.id} value={item.id}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box
              component="span"
              aria-hidden="true"
              sx={{
                width: 14,
                height: 14,
                borderRadius: '50%',
                bgcolor: item.navy,
                boxShadow: `inset 0 0 0 3px ${item.accent}`,
              }}
            />
            {item.label}
          </Box>
        </MenuItem>
      ))}
    </TextField>
  );
};

export default ColorwayPicker;
